import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTiktok,
} from "react-icons/fa";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  const mapLink = "https://maps.app.goo.gl/MFSHCUPgWGzYNQPj8";

  return (
    <footer className="bg-[#E62E2D] text-white relative overflow-hidden">
      {/* Light overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-black/20 pointer-events-none"></div>

      <div className="container mx-auto px-6 py-10 relative z-10 animate-fadeIn">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {/* Contact Info */}
          <div className="col-span-2 md:col-span-1 space-y-4">
            <h3 className="text-2xl font-semibold tracking-wide">Isuzu Ravi</h3>
            <p className="text-gray-100 text-sm leading-relaxed">
              Leading Isuzu dealer in Pakistan
            </p>

            <div className="space-y-3 mt-4 text-sm">
              {[{ Icon: Mail, text: "cr@isuzuravi.com" },
              { Icon: Phone, text: "+92 (42)-35299549" },
              { Icon: Phone, text: "UAN 111-700-900" }
              ].map(({ Icon, text }, idx) => (
                <div key={idx} className="flex items-center gap-3 group cursor-pointer">
                  <Icon size={18} className="transition-transform group-hover:scale-110" />
                  <span className="transition-all group-hover:translate-x-1">{text}</span>
                </div>
              ))}

              {/* Clickable address */}
              <div
                className="flex items-center gap-3 group cursor-pointer"
                onClick={() => window.open(mapLink, "_blank")}
              >
                <MapPin size={18} className="transition-transform group-hover:scale-110" />
                <span className="underline underline-offset-2 hover:text-gray-200 transition-colors">
                  Isuzu Ravi Motors, Thokar Niaz Baig Flyover, Canal Colony, Lahore, 53700
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 relative after:absolute after:-bottom-2 after:left-0 after:w-10 after:h-[2px] after:bg-white after:rounded-full">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm">
              {[
                ["Home", "/"],
                ["About Us", "/about"],
                ["Customer Relations", "/customer"],
                ["FAQ", "/faq"],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="relative inline-block transition-all hover:translate-x-1 hover:text-gray-200"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 relative after:absolute after:-bottom-2 after:left-0 after:w-10 after:h-[2px] after:bg-white after:rounded-full">
              Services
            </h4>
            <ul className="space-y-2 text-sm">
              {[
                ["Sales", "/sales"],
                ["Service", "/service"],
                ["Parts", "/parts"],
                ["Videos", "/videos"],
                ["Contact Us", "/contact"],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="relative inline-block transition-all hover:translate-x-1 hover:text-gray-200"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Media */}
          <div className="flex flex-col items-start md:items-center">
            <h4 className="text-lg font-semibold mb-4 text-left md:text-center">
              Connect With Us
            </h4>

            <div className="flex space-x-5">
              {[
                { Icon: FaFacebookF, link: "https://www.facebook.com/isuzuravimotors" },
                { Icon: FaInstagram, link: "https://www.instagram.com/isuzuravimotors/?hl=en" },
                { Icon: FaTiktok, link: "https://www.tiktok.com/@crisuzuravi" },
                { Icon: FaYoutube, link: "https://www.youtube.com/@isuzuravimotorslahorepakis918" },
              ].map(({ Icon, link }, idx) => (
                <a
                  key={idx}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group transform transition-all duration-300 hover:-translate-y-1"
                >
                  <div
                    className="
          rounded-full p-3 
          bg-white 
          transition-all duration-300 
          shadow-md 
          group-hover:bg-black 
          group-hover:shadow-xl
        "
                  >
                    <Icon
                      size={22}
                      className="
            text-black 
            transition-colors duration-300 
            group-hover:text-white
            group-hover:scale-110
            transform
          "
                    />
                  </div>
                </a>
              ))}
            </div>


          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-white/20 mt-6 py-4 text-center text-sm text-gray-100">
        <p className="opacity-90 tracking-wide">
          &copy; {new Date().getFullYear()} IGM — All Rights Reserved | Designed & Powered by
          Synergy Soft Intl.
        </p>
      </div>

    </footer>
  );
};

export default Footer;
